/**
 * EditableTable's FilterDialog strings.
 */
import React from 'react';

export default {
    // Section labels
    d_sort: 'Sort',
    h_sort: '<div><p>Sort values, either ascending (A-Z, 1-9) or descending (Z-A, 9-1).</p></div>',
    d_filter: 'Filter',
    /** Dialog title prefix — read aloud as "Filter for Field: <column name>". */
    d_filterForField: 'Filter for Field:',
    d_type: 'Type',
    d_limitToValues: 'Limit to values',

    // Sort actions
    d_clearSort: 'Clear sort',
    d_clearFilter: 'Clear filter',

    // Sort priority (multi-column sort)
    d_sortPriority: 'Sort priority',
    d_sortPriorityHelp: 'Drag to reorder. First entry is the primary sort.',
    d_sortPriorityHint: (params: {position: number, total: number}) => `Sorting at priority ${params.position} of ${params.total}`,
    d_dragToReorder: 'Drag to reorder',
    d_thisColumn: 'this column',
    d_addSortColumn: 'Add a column to sort by…',
    d_sortedAscClickToReverse: 'Sorted ascending — click to reverse',
    d_sortedDescClickToReverse: 'Sorted descending — click to reverse',

    // Sort labels by column type
    d_sortAsc: 'Ascending',
    d_sortDesc: 'Descending',
    d_sortAlphaAsc: 'A → Z',
    d_sortAlphaDesc: 'Z → A',
    d_sortNumericAsc: 'Smallest first',
    d_sortNumericDesc: 'Largest first',
    d_sortDateAsc: 'Oldest first',
    d_sortDateDesc: 'Newest first',

    // Operator labels (shared across types where applicable)
    d_op_contains: 'Contains',
    d_op_not_contains: 'Does not contain',
    d_op_equals: 'Equals',
    d_op_not_equals: 'Does not equal',
    d_op_begins: 'Begins with',
    d_op_ends: 'Ends with',
    d_op_gt: 'Greater than',
    d_op_gte: 'Greater than or equal to',
    d_op_lt: 'Less than',
    d_op_lte: 'Less than or equal to',
    d_op_between: 'Between',
    d_op_top_n: 'Top N',
    d_op_bottom_n: 'Bottom N',
    d_op_on: 'On',
    d_op_before: 'Before',
    d_op_after: 'After',
    d_op_relative: 'Relative date…',
    d_op_ytd: 'Year to date',
    d_op_empty: 'Is empty',
    d_op_not_empty: 'Is not empty',

    // Joiner & boolean
    d_and: 'AND',
    d_or: 'OR',
    d_true: 'True',
    d_false: 'False',
    d_either: 'Either',
    d_boolPrompt: (column: string) => <>Show rows where <em>{column}</em> is</>,

    // Footer + misc
    d_addCondition: 'Add a condition',
    d_addAnotherCondition: 'Add another condition',
    d_apply: 'Apply',
    d_cancel: 'Cancel',
    d_close: 'Close',
    d_noValueNeeded: 'No value needed',
    d_searchValues: 'Search values',
    d_selectAll: '(Select all)',
    d_matchSummary: (params: {n: number, total: number}) => `${params.n.toLocaleString()} of ${params.total.toLocaleString()} rows match`,
    d_searchHint: (column: string) => `Show rows where ${column.toLowerCase()}…`,

    // Type chip labels
    d_typeText: 'Text',
    d_typeNumber: 'Number',
    d_typeMoney: 'Currency',
    d_typeDate: 'Date',
    d_typeBoolean: 'Yes / No',
    d_typeOther: 'Value',

    // Relative date groups + values
    d_rel_group_day: 'Day',
    d_rel_group_week: 'Week',
    d_rel_group_month: 'Month',
    d_rel_group_year: 'Year',
    d_rel_today: 'Today',
    d_rel_yesterday: 'Yesterday',
    d_rel_tomorrow: 'Tomorrow',
    d_rel_this_week: 'This week',
    d_rel_last_week: 'Last week',
    d_rel_next_week: 'Next week',
    d_rel_this_month: 'This month',
    d_rel_last_month: 'Last month',
    d_rel_next_month: 'Next month',
    d_rel_this_year: 'This year',
    d_rel_last_year: 'Last year',
    d_rel_next_year: 'Next year',
};
